module.exports = __webpack_public_path__ + "static/img/our-customers.82220ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/our-customers.jpg
// module id = s6U2
// module chunks = 0